import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { UserRequestDTO } from '../shared/models/UserRequestDto';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private httpService: HttpService) { }

  getAllStates(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
        console.log('getAll States')
      })
    );
  }

  getListDevices() {
    return this.httpService.getListDevices().pipe(
      tap((data) => {
      })
    );
  }

  createDevice(device: DeviceDTO) {
    return this.httpService.createDevice(device).pipe(
      tap((data) => {
      })
    );
  }
  
  exportToExcelListDevices(){
    return this.httpService.exportToExcelListDevices().pipe(
      tap((data) => {
      })
    );
  }
}